import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Logo ufficiale "Meteo Via Loreto".
 * Sceglie automaticamente la variante:
 *  - chiara (bianco+oro) solo quando la navbar è trasparente sopra la hero della Home
 *  - scura (nero+oro) in tutti gli altri casi (pagine interne, navbar scrollata, footer con variant="light" ecc.)
 */
export default function BrandLogo({ className = "h-12 lg:h-16", variant = "auto" }) {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";
  const onTransparentHero = isHome && !scrolled;

  // variant "light" forza la versione bianca (footer scuro).
  // variant "dark"  forza la versione nera.
  // variant "auto" (default) sceglie in base al contesto.
  const useLight = variant === "light" || (variant === "auto" && onTransparentHero);
  const src = useLight ? "/logo/meteo-via-loreto-light.png" : "/logo/meteo-via-loreto.png";

  return (
    <img
      src={src}
      alt="Meteo Via Loreto — Stazione Meteorologica Palestrina"
      className={`${className} w-auto object-contain select-none transition-opacity duration-500`}
      draggable={false}
      data-testid="brand-logo"
    />
  );
}
